import React from "react";
import introData from "data/sections/intro.json";
import { Swiper, SwiperSlide } from "swiper/react";
import "./no-code-header.css";

import SwiperCore, { Autoplay, Navigation, Pagination, Parallax } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import removeSlashFromPagination from "common/removeSlashpagination";
import fadeWhenScroll from "common/fadeWhenScroll";
import GirlSvg from "../Svg/girlSvg";
import WaveSvg from "../Svg/waveSvg";
import { StaticImage } from "gatsby-plugin-image";

SwiperCore.use([Autoplay, Navigation, Pagination, Parallax]);

const NoCodeHeaderServices = ({ servicesData }) => {
  const sliderRef = null;
  const [load, setLoad] = React.useState(true);
  React.useEffect(() => {
    fadeWhenScroll(document.querySelectorAll(".fixed-slider .caption"));
    setTimeout(() => {
      removeSlashFromPagination();
      setLoad(false);
    }, 1000);
  }, []);

  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const paginationRef = React.useRef(null);

  return (
    <>
      <header ref={sliderRef} className="  text-center mt-5">
        <div className="swiper-container parallax-slider">
          {!load ? (
            <Swiper
              speed={1000}
              autoplay={{
                delay: 5500,
                disableOnInteraction: false,
              }}
              loop={true}
              // parallax={true}
              navigation={{
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current,
              }}
              pagination={{
                type: "fraction",
                clickable: true,
                el: paginationRef.current,
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
                swiper.params.pagination.el = paginationRef.current;
              }}
              onSwiper={(swiper) => {
                setTimeout(() => {
                  for (var i = 0; i < swiper.slides.length; i++) {
                    swiper.slides[i].childNodes[0].setAttribute(
                      "data-swiper-parallax",
                      0.75 * swiper.width,
                    );
                  }

                  swiper.params.navigation.prevEl = navigationPrevRef.current;
                  swiper.params.navigation.nextEl = navigationNextRef.current;

                  swiper.params.pagination.el = paginationRef.current;

                  swiper.navigation.destroy();
                  swiper.navigation.init();
                  swiper.navigation.update();

                  swiper.pagination.destroy();
                  swiper.pagination.init();
                  swiper.pagination.update();
                });
              }}
              className="swiper-wrapper"
              slidesPerView={1}
            >
              {introData.map((slide) => (
                <SwiperSlide
                  key={slide.id}
                  className="swiper-slide  swiperslider"
                >
                  <div className="bg-img valign intro-sec">
                    <img
                      loading="lazy"
                      src={slide.slide1code}
                      alt="code"
                      width="50"
                      className="slide-code01 animated-element"
                    />
                    <img
                      loading="lazy"
                      src={slide.slide1js}
                      alt="js"
                      width="50"
                      className="slide-js animated-element"
                    />
                    {/* <img src={slide.mainObj} alt="" width="50" className="slide-mainobj" /> */}
                    <span className="slide-mainobj animated-element">
                      <GirlSvg />
                    </span>

                    {/* html svg */}
                    <img
                      loading="lazy"
                      src={slide.slideRight1}
                      alt="html"
                      width="50"
                      className="slide-right1 animated-element"
                    />
                    <img
                      loading="lazy"
                      src={slide.slideRight2}
                      alt="css"
                      width="50"
                      className="slide-right2 animated-element"
                    />
                    <img
                      loading="lazy"
                      src={slide.slideRight3}
                      alt="man"
                      width="50"
                      className="slide-right3 animated-element"
                    />

                    <div
                      className="container  "
                      style={{ padding: "70px 0px 0px 0px" }}
                    >
                      <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-7">
                          <div className="caption center mt-30">
                            <h6 className=" text-left animate-charcter center-sc-425">
                              {servicesData.title}
                            </h6>
                            <h1 className="text-left center-sc-425">
                              Turn Your Idea <br />
                              to{" "}
                              <span className="animate-charcter">
                                Into a Fundable,
                              </span>{" "}
                              <br />
                              Market-Ready Product
                            </h1>
                            <p>{servicesData.subTitle}</p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-5 text-right center-sc-425">
                          <p className="mt-30 text-right center-sc-425">
                            We’re a premium no-code product studio built for
                            bold founders who won’t settle for average. We help
                            you design, build, and launch scalable products that
                            users enjoy and investors believe in — without long
                            dev cycles or bloated budgets.
                          </p>
                          <div className="cta-sec center-sc-425">
                            <a
                              href="#contact"
                              className="butn bord curve banner-cta"
                              style={{marginTop:"50px"}}
                            >
                              Book strategy call
                            </a>
                            <a
                              href="/no-code-app-budget-calculator"
                              className="budget-calc-link"
                              style={{fontSize:"medium"}}
                            >
                              Calculate Your App Budget
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : null}
          <div className="setone setwo">
            <div
              ref={navigationNextRef}
              className="swiper-button-next swiper-nav-ctrl next-ctrl cursor-pointer"
            >
              <i className="fas fa-chevron-right"></i>
            </div>
            <div
              ref={navigationPrevRef}
              className="swiper-button-prev swiper-nav-ctrl prev-ctrl cursor-pointer"
            >
              <i className="fas fa-chevron-left"></i>
            </div>
          </div>
          <div
            ref={paginationRef}
            className="swiper-pagination top botm text-dark"
          ></div>
        </div>

        <div className="hero-img-container">
          <StaticImage
            className="m-0"
            src="../../images/no-code/tilted.png"
            alt="No-code product preview"
          />
          <div className="overlay"></div>
        </div>
      </header>
    </>
  );
};

export default NoCodeHeaderServices;
